import React from "react";
import { useCookies } from "react-cookie";
import { checkAuth } from "./checkAuth";
import { Navigate, Outlet } from "react-router-dom";

export default function PrivateRoute() {
  const [cookies] = useCookies(["token"]);
  const isLogin = checkAuth(cookies.token);
  return <>{isLogin ? <Outlet /> : <Navigate to="/onBoarding" />}</>;
}
